import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import { TableCell, TableRow } from "@material-ui/core";
import {
  activeUser,
  updateUser,
  startLoadAssignedOffices,
} from "../../../module/admin/redux/actions/usersActions";
import { CustomizedIcons } from "../../custom/CustomizedIcons";
import { AntSwitch } from "../../custom/CustomizedSwitch";
import {
  uiOpenModalAssignOffices,
  uiOpenModalAssignModules,
  uiOpenModalEdit,
  uiOpenSuccessChange,
  uiOpenModalDelete,
} from "../../../redux/actions/uiActions";
import { IUserForm } from "../../../module/admin/form/IUsersForm";
import { db } from "../../../config/firebase/firebase-config";
import { restricUser } from "../../../module/admin/firebase/UsersService";

export const UsersBody = (user: IUserForm) => {
  const [state, setState] = useState({
    checkedA: user.active,
    restricUser: false,
  });

  const dispatch = useDispatch();

  const onEditUser = () => {
    dispatch(activeUser(user));
    dispatch(uiOpenModalEdit());
  };

  const onDeleteUser = () => {
    dispatch(activeUser(user));
    dispatch(uiOpenModalDelete());
  };

  const onAssignModules = () => {
    dispatch(activeUser(user));
    dispatch(uiOpenModalAssignModules());
  };

  const onAssignOffice = async () => {
    dispatch(activeUser(user));
    await dispatch(startLoadAssignedOffices(user.offices));
    await dispatch(uiOpenModalAssignOffices());
  };

  const handleRestricUser = (user: { id: string; restricUser: boolean }) => {
    restricUser(user).then((response) => {
      if (response.ok) {
        dispatch(uiOpenSuccessChange());
      }
    });
  };

  // Función para cambiar estado
  const handleChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    setState({ ...state, [event.target.name]: event.target.checked });
    const check = event.target.checked;
    if (event.target.name == "restricUser") {
      setState({ ...state, restricUser: event.target.checked });
      handleRestricUser({
        id: event.target.value,
        restricUser: event.target.checked,
      });
    } else {
      // Actualizacion en BD
      await db
        .collection("Users")
        .doc(user.id)
        .set({ active: check }, { merge: true });
      dispatch(updateUser({ ...user, active: check }));
      dispatch(uiOpenSuccessChange());
    }
  };

  useEffect(() => {
    if (user) {
      setState({ ...state, restricUser: user.restricUser });
    }
  }, []);
  return (
    <TableRow key={user.document}>
      <TableCell component="th" scope="row">
        {user.firstName} {user.secondName} {user.firstLastName}{" "}
        {user.secondLastName}
      </TableCell>
      <TableCell>{user.typeDoc}</TableCell>
      <TableCell>{user.document}</TableCell>
      <TableCell>{user.email}</TableCell>
      <TableCell align="center">
        <AntSwitch
          checked={state.checkedA}
          name="checkedA"
          onChange={handleChange}
        />
      </TableCell>
      <TableCell align="center">
        <AntSwitch
          name="restricUser"
          onChange={handleChange}
          value={user.id}
          checked={state.restricUser}
        />
      </TableCell>
      <TableCell align="center">
        <CustomizedIcons
          editIcon
          deleteIcon
          assignModulesIcon
          assignOfficeIcon
          onEdit={onEditUser}
          onDelete={onDeleteUser}
          onAssignModules={onAssignModules}
          onAssignOffice={onAssignOffice}
        />
      </TableCell>
    </TableRow>
  );
};
